import React from 'react';
import { 
  Box, 
  Container, 
  Typography,
} from '@mui/material';
import FormOrchestrator from '../FormContext/FormOrchestrator';
import { FormStep } from '../FormContext/types';
import { FormType, FormTypes } from '../../../types/PatientFormTypes';
import PageTitle from '@components/PageTitle';
import { getIsMobile } from '../../../utils/helpers';

interface FormContainerProps {
  title: string;
  description: string;
  formType: FormType;
  patientId: string;
  appointmentId?: string;
  therapyId?: string;
  steps: FormStep[];
  defaultValues?: any;
}


export const FormContainer: React.FC<FormContainerProps> = ({
  title,
  description,
  formType,
  patientId,
  appointmentId,
  therapyId,
  steps,
  defaultValues,
}) => {
  const isMobile = getIsMobile();

  // Form configuration
  const formConfig = {
    steps,
    formType,
    allowSkipSteps: formType === FormTypes.DETAILS,
  };

  return (
    <Container maxWidth="md" sx={{ px: { xs: 0.5, md: 2 } }}>
      <Box sx={{ py: { xs: 1, md: 2 } }}>
        <PageTitle title={title} />
        {!isMobile && <Typography variant="body1" color="text.secondary" paragraph>
          {description}
        </Typography>}
        <FormOrchestrator
          patientId={patientId}
          appointmentId={appointmentId}
          therapyId={therapyId}
          formConfig={formConfig}
          defaultValues={defaultValues}
        />
      </Box>
    </Container>
  );
};